import { render, staticRenderFns } from "./LG.vue?vue&type=template&id=10328c1e&scoped=true"
import script from "./LG.vue?vue&type=script&lang=js"
export * from "./LG.vue?vue&type=script&lang=js"
import style0 from "./LG.vue?vue&type=style&index=0&id=10328c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10328c1e",
  null
  
)

export default component.exports